import { render, staticRenderFns } from "./Passengers.vue?vue&type=template&id=17c2857d"
import script from "./Passengers.vue?vue&type=script&lang=js"
export * from "./Passengers.vue?vue&type=script&lang=js"
import style0 from "./Passengers.vue?vue&type=style&index=0&id=17c2857d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports